import { gql } from "@apollo/client";
import { esc } from "./formatters";

export const buildAddKidsWorldMutation = (p: {
    yearAndMonth: string;
    v1?: string;
    v2?: string;
    v3?: string;
    v4?: string;
    v5?: string;
    admin: string;
}) => gql`
  mutation AddKW {
    addKidsWorldVideo(
      parameter: {
        yearAndMonth: "${esc(p.yearAndMonth)}"
        ${p.v1 ? `vimeoId1: "${esc(p.v1)}"` : ""}
        ${p.v2 ? `vimeoId2: "${esc(p.v2)}"` : ""}
        ${p.v3 ? `vimeoId3: "${esc(p.v3)}"` : ""}
        ${p.v4 ? `vimeoId4: "${esc(p.v4)}"` : ""}
        ${p.v5 ? `vimeoId5: "${esc(p.v5)}"` : ""}
        adminFirstUser: "${esc(p.admin)}"
      }
    ) {
      count
      error
    }
  }
`;

export const buildUpdateKidsWorldMutation = (p: {
    id: number;
    yearAndMonth: string;
    v1?: string;
    v2?: string;
    v3?: string;
    v4?: string;
    v5?: string;
    admin: string;
}) => gql`
  mutation UpdateKW {
    updateKidsWorldVideo(
      parameter: {
        kidsWorldVideoId: ${p.id}
        yearAndMonth: "${esc(p.yearAndMonth)}"
        ${p.v1 ? `vimeoId1: "${esc(p.v1)}"` : ""}
        ${p.v2 ? `vimeoId2: "${esc(p.v2)}"` : ""}
        ${p.v3 ? `vimeoId3: "${esc(p.v3)}"` : ""}
        ${p.v4 ? `vimeoId4: "${esc(p.v4)}"` : ""}
        ${p.v5 ? `vimeoId5: "${esc(p.v5)}"` : ""}
        adminFirstUser: "${esc(p.admin)}"
      }
    ) {
      count
      error
    }
  }
`;
